import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const editUsedBy = ( {data, usedById} : {data: IPostEditUsedBy | {}, usedById: number}): Promise<string> => {
  return axiosDefaultApi.put(`api/UsedBy/UpdateUsedBy/${usedById}`, data);
};

type QueryFnType = typeof editUsedBy;

type UseEditUsedByOptions = {
  data: IPostEditUsedBy | {};
  usedById: number;
  config?: MutationConfig<QueryFnType>;
};

export const useEditUsedBy = ({ config }: UseEditUsedByOptions) => { 
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην επεξεργασία της παραμέτρου 'Χρήση από'.`, 500);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllUsedBy"])
            addNotification(`Η παράμετρος 'Χρήση από' Ενημερώθηκε`, 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: editUsedBy,
    })
}